function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.2 12.699V8.976c-4.726 0-7.837 1.445-10.2 4.624.952-4.539 3.587-9.061 10.2-9.979V0L17 6.341l-6.8 6.358z",
  fill: "currentColor",
  fillRule: "evenodd"
});
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgShare;